import * as HIcons from '@heroicons/react/outline';
import * as HIconsSolid from '@heroicons/react/solid';
import classNames from 'classnames';

const icons: { [key: string]: any } = { ...HIcons };
const iconsSolid: { [key: string]: any } = { ...HIconsSolid };

export enum IconSize {
  Small,
  Large,
}

interface IconsProps {
  name: string;
  isSolid?: boolean;
  className?: string;
  size?: IconSize;
}

const SIZE_STYLE_MAP = {
  [IconSize.Small]: 'min-w-4 w-4',
  [IconSize.Large]: 'min-w-6 w-6',
};

const Icon = ({
  name,
  className,
  size = IconSize.Large,
  isSolid,
}: IconsProps) => {
  const styles = SIZE_STYLE_MAP[size];
  const { [name]: HeroIcon } = isSolid ? iconsSolid : icons;

  if (!HeroIcon) {
    throw new Error(`Hero icon with name ${name} not found`);
  }

  return (
    <HeroIcon className={classNames(className, styles)} aria-hidden="true" />
  );
};

export default Icon;
